import React, {Fragment, useEffect, useState} from "react";
import './AdminDashboard.scss'
import PurpleTab from "./PurpleTab";
import {S360_urls} from "./constants/S360_constants";
import NewsTable from "./Tables/NewsTable";
import {getActiveConcernReportsForSChool} from "../DataFunctions/ConcernReportDataFns";
import {getDataFromResponse} from "../DataFunctions/BaseDataFns";
import SpinnerDiv from "../ui/ReactSpinnerDiv";
import UsageGraphSelector from "./UsageGraphSelector";
import UsageWeekSummary from "./UsageWeekSummary";
import phpVars from 'phpVars';
import {UserTypeNames} from "../globals";
import {UserTypes} from "../globals";

const S360Link = ( props ) =>
{
    const btnClass = props.flashBg ? ' generic-button blink-bg' : 'generic-button';

    return (
        <div className='icon-content'>
            <div className='selection-layout'>
                <a href={props.url} title={props.title}>
                    <div className={btnClass}>
                        <div className='shortcut'>
                            <div>{props.title}</div>
                            <i className={ props.icon }></i>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    )
}

const AdminDashboard = (props) =>
{
    const [data, setData] = useState({ isLoading: true, data: [] });

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        if(props.school_id !== undefined)
        {
            getActiveConcernReportsForSChool(props.school_id, (response) =>
            {
                setData({isLoading: false, data: getDataFromResponse(response)});
            });
        }
    };

    const buildMyAccountUrl = ( url ) =>
    {
        const myAccountUrl = S360_urls.MY_ACCOUNT_URL + '&userId=' + props.user_id + '&user_type=' + UserTypes.USER_TYPE_ADMIN;
        return myAccountUrl
    }

    const pageContent = () =>
    {
        return (
            <Fragment>
                <div className='admin-dash-wrapper'>
                    <div className='admin-dash-wrapper-left'>
                        <div className='column-wrapper'>
                            <PurpleTab title='Shortcuts'>
                                <div className='link-wrapper-internal'>
                                    <S360Link url={S360_urls.DASHBOARDS_URL} title='Dashboard' icon="glyphicon glyphicon-dashboard"/>
                                    <S360Link url={S360_urls.CREATE_SETTING_URL} title='Create Setting' icon="glyphicon glyphicon-home"/>
                                    <S360Link url={S360_urls.CREATE_RESOURCE_URL} title='Create Resource' icon="glyphicon glyphicon-book"/>
                                    <S360Link url={buildMyAccountUrl()} title='My Account' icon="glyphicon glyphicon-cog"/>
                                </div>
                            </PurpleTab>
                        </div>

                        <div className='column-wrapper'>
                            <UsageGraphSelector school_id={props.school_id}/>
                        </div>

                    </div>

                    <div className='admin-dash-wrapper-right'>
                        <div className='column-wrapper'>
                            <PurpleTab title='NEWS'>
                                <div className='news-table'>
                                    <NewsTable school_id={props.school_id}></NewsTable>
                                </div>
                            </PurpleTab>
                        </div>

                        <div className='column-wrapper'>
                            {phpVars.user_type === UserTypeNames.USER_TYPE_NAME_ADMIN && <UsageWeekSummary title='School360 Access this Week' school_id={props.school_id}/>}
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    return data.isLoading === true ? <SpinnerDiv /> : pageContent();
};

export default AdminDashboard;
